import { Component, Input } from '@angular/core';
import { OrderReplacementItem, ColorClass, OrderItemState } from 'shared';

@Component({
    selector: 'app-order-replacement-item',
    templateUrl: './order-replacement-item.component.html',
    styleUrls: ['./order-replacement-item.component.scss'],
})
export class OrderReplacementItemComponent {
    public ColorClass = ColorClass;
    @Input() public orderItemState: OrderItemState;
    @Input() public orderReplacementItem: OrderReplacementItem;
    @Input() public color: ColorClass = ColorClass.White;
    @Input() public label: string;
    public get quantity(): number {
        return this.orderItemState === OrderItemState.Approved
            ? this.orderReplacementItem.quantity
            : 0;
    }
}
